export default "__VITE_ASSET__DVElqVYF__"